function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAngryPack2 = function SvgAngryPack2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    viewBox: "0 0 128 128"
  }, props), /*#__PURE__*/React.createElement("radialGradient", {
    id: "angry-pack2_svg__a",
    cx: 63.6,
    cy: 2584.9,
    r: 56.96,
    gradientTransform: "translate(0 -2522)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#fac742"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    style: {
      stopColor: "#fac440"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#fbba3b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    style: {
      stopColor: "#fba931"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    style: {
      stopColor: "#fc9224"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    style: {
      stopColor: "#fe7413"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff5100"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.6 118.8c-27.9 0-58-17.5-58-55.9S35.7 7 63.6 7c15.5 0 29.8 5.1 40.4 14.4 11.5 10.2 17.6 24.6 17.6 41.5s-6.1 31.2-17.6 41.4c-10.6 9.3-25 14.5-40.4 14.5z",
    style: {
      fill: "url(#angry-pack2_svg__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.49 29.67c5.33 8.6 8.11 18.84 8.11 30.23 0 16.9-6.1 31.2-17.6 41.4-10.6 9.3-25 14.5-40.4 14.5-18.06 0-37-7.35-48.18-22.94 10.76 17.66 31 25.94 50.18 25.94 15.4 0 29.8-5.2 40.4-14.5 11.5-10.2 17.6-24.5 17.6-41.4 0-12.74-3.47-24.06-10.11-33.23z",
    style: {
      fill: "#d84213"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.94 103.14a2.21 2.21 0 0 1-.89-.62 25.41 25.41 0 0 0-35.93-.69l-.69.69a2.18 2.18 0 0 1-3.09.21 1.84 1.84 0 0 1-.49-2.08C45.83 93 54.69 87 64.74 87s18.91 6 21.89 13.64c.3.73.1 1.56-.49 2.08a2.2 2.2 0 0 1-2.2.42zm-25.8-34.32C55.9 66 46.67 60.58 43.34 59a22.9 22.9 0 0 0-3.85-1.37c-.24-.07-.5-.1-.75-.1A2.87 2.87 0 0 0 36 59.82a2.92 2.92 0 0 0 1.67 3.32c1.57.77 4.31 2.23 7.15 3.84A7.83 7.83 0 0 0 41 73.71v1.46a7.5 7.5 0 0 0 15 0v-1.63a3 3 0 0 0 2.5-1.67c.49-1 .35-2.19-.36-3.05zm35.38-9a2.87 2.87 0 0 0-3.54-2.17c-1.32.33-2.61.79-3.85 1.35-3.33 1.56-12.56 7-14.8 9.8a2.84 2.84 0 0 0-.33 3.07 3 3 0 0 0 2.51 1.67v1.63a7.5 7.5 0 0 0 15 0v-1.46c0-2.75-1.45-5.3-3.81-6.71 2.84-1.61 5.58-3.07 7.15-3.84a2.9 2.9 0 0 0 1.67-3.34z",
    style: {
      fill: "#422b0d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.12 68.45a2.87 2.87 0 0 0-3.82 1.34 2.87 2.87 0 0 0 .6 3.3c1.42.68 3.13.08 3.82-1.34a2.87 2.87 0 0 0-.6-3.3zm32.51 0a2.87 2.87 0 0 0-3.82 1.34 2.87 2.87 0 0 0 .6 3.3c1.42.68 3.13.08 3.82-1.34a2.87 2.87 0 0 0-.6-3.3z",
    style: {
      fill: "#896024"
    }
  }));
};
export default SvgAngryPack2;